import { supabase } from '../lib/supabase';

// Haalt ALLE actieve (en opgezegde-maar-nog-lopende) memberships van een
// client op in één query — géén .limit(1)/.maybeSingle(), want een client
// kan meerdere gelijktijdige abonnementen hebben (bv. Small Group + PT
// 1-op-1). Zelfde querylogica als de mobiele app (services/database.js
// getActiveClientMemberships), gerepliceerd voor de web-portal's eigen
// datalaag (aparte tech-stack, geen gedeeld package).
export async function getActiveClientMemberships(clientId) {
  const { data, error } = await supabase
    .from('client_memberships')
    .select(`
      id,
      client_id,
      current_credits,
      current_pt_credits,
      current_pt_plus_credits,
      current_small_group_credits,
      pt_credits_per_month,
      pt_plus_credits_per_month,
      small_group_credits_per_month,
      session_type,
      start_date,
      end_date,
      is_custom,
      is_rolling,
      cancellation_date,
      initial_end_date,
      last_credit_booking_at,
      custom_name,
      custom_price,
      custom_credits,
      custom_duration_days,
      membership_type:membership_types(id, name, legacy_credits_per_period, session_type, sessions_per_week_frequency)
    `)
    .eq('client_id', clientId)
    .eq('status', 'active')
    .order('start_date', { ascending: false });
  if (error) throw error;
  return data || [];
}

// Bepaalt welke creditpool getoond wordt voor een membership: de pool die
// bij dit abonnement hoort (pt/pt_plus/small_group), met legacy
// current_credits als fallback voor oudere abonnementen zonder
// pool-opsplitsing. Zelfde logica als HomeScreen.js (mobiele app).
export function primaryMembershipCredits(m) {
  if (m.pt_credits_per_month > 0 || m.current_pt_credits > 0) return m.current_pt_credits || 0;
  if (m.pt_plus_credits_per_month > 0 || m.current_pt_plus_credits > 0) return m.current_pt_plus_credits || 0;
  if (m.small_group_credits_per_month > 0 || m.current_small_group_credits > 0) return m.current_small_group_credits || 0;
  return m.current_credits || 0;
}

export function membershipDisplayName(m, unknownLabel) {
  return m.is_custom && m.custom_name ? m.custom_name : (m.membership_type?.name || unknownLabel);
}
